import {ICardProject} from '../interfaces/ICardProject';
import LoginHtmlCss from '../assets/login_html_and_css.png';
import Pokedex from '../assets/screen_pokedex.png';
import linktree from '../assets/link_tree.png';
import dulceEncanto from '../assets/dulce_encanto.png';
import thegeoengineering from '../assets/the_geo_engineering.png';
import rubber from '../assets/web_rubber.png';
import jacaranda_app from '../assets/jacaranda_app.png';

export const projects: ICardProject[] = [
    {
        id: 1,
        title: "Jacaranda App",
        description: "Aplicacion para la venta en linea de un supermercado",
        content: "Proyecto para la venta en linea de un supermercado, permite administrar pedidos y productos, asi como mantener la disponibilidad de lso articulos",
        image: jacaranda_app,
        tech: [
            "React",
            "CSS",
            "TS",
            "Firebase"
        ],
        url:"https://geomunioz.github.io/jacaranda_app_ts/"
    },
    {
        id: 2,
        title: "thegeoengineering.com",
        description: "Sitio web thegeoengineering.com",
        content: "Sitio web para la empresa The Geo Engineering",
        image: thegeoengineering,
        tech: [
            "HTML",
            "CSS",
            "JS"
        ],
        url:"https://thegeoengineering.com/"
    },
    {
        id: 3,
        title: "serviciosrubber.com.mx",
        description: "Sitio web serviciosrubber.com.mx",
        content: "Sitio web para la empresa Rubber",
        image: rubber,
        tech: [
            "HTML",
            "CSS",
            "JS"
        ],
        url:"https://serviciosrubber.com.mx/"
    },
    {
        id: 4,
        title: "Login",
        description: "Maquetado de Login construido con HTML y CSS",
        content: "Construcción de Login con tecnologias HTML y CSS",
        image: LoginHtmlCss,
        tech: [
            "HTML",
            "CSS"
        ],
        url:"https://geomunioz.github.io/loginWeb/"
    },
    {
        id: 5,
        title: "Pokedex",
        description: "Maquetado de Pokedex y consumo de PokeApi",
        content: "Construcción de Pokedex que permite la busqueda de Pokemones mediante No. Pokedex",
        image: Pokedex,
        tech: [
            "HTML",
            "CSS",
            "JS",
        ],
        url:"https://geomunioz.github.io/Pokedex/"
    },
    {
        id: 6,
        title: "LinkTree",
        description: "Maquetado de Link Tree Personal",
        content: "Construcción de una pagina de link personales ",
        image: linktree,
        tech: [
            "HTML",
            "CSS",
        ],
        url:"https://geomunioz.github.io/LinkTree/"
    },
    {
        id: 7,
        title: "Dulce Encanto | Pastelería",
        description: "Maquetado de Link Tree Personal",
        content: "Dulce Encanto es un proyecto desarrollado como proyecto escolar, su objetivo es ayudar en la gestión de una pastelería de manera tal que el administrador pueda agregar, eliminar, actualizar y consultar sus productos, también el cliente tendrá la oportunidad de realizar el pedido de estos productos a través de esta aplicación incluyendo a su carrito de compra lo necesario. \n El proyecto esta construido con tecnologías HTML, CSS, y JS en la parte de frontend y en backend se empleo PHP como lenguaje de programación en la construcción de la API REST y MYSQL para el almacenamiento de la información.",
        image: dulceEncanto,
        tech: [
            "HTML",
            "CSS",
            "PHP",
            "MYSQL"
        ],
        url:""
    },    
];